import styled, { css } from 'styled-components';
import MapSVG from 'assets/img/main/map.png';
import RectangleSVG from 'assets/img/country/rectangle.png';
import { Title } from 'components';

export const TitleMain = styled(Title)`
  font-family: 'Ubuntu', sans-serif;
  font-size: ${({ size }) => size};
  font-weight: ${({ weight }) => weight};
  display: ${({ display }) => display};
  flex-direction: ${({ direction }) => direction};
  align-items: ${({ align }) => align};
  margin: ${({ margin }) => margin};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  max-width: ${({ maxWidth }) => maxWidth};

  @media ${({ theme }) => theme.deviceMin.desktop1890} {
    padding: ${({ paddingFrom1890 }) => paddingFrom1890};
  }

  @media ${({ theme }) => theme.device.desktop1890} {
    padding: ${({ padding1890 }) => padding1890};
  }

  @media ${({ theme }) => theme.device.laptop1100} {
    font-weight: ${({ weightMobile }) => weightMobile};
    font-size: ${({ sizeM }) => sizeM};
    padding: ${({ padding1100 }) => padding1100};
    max-width: ${({ maxWidthM }) => maxWidthM};
  }

  @media ${({ theme }) => theme.device.tablet} {
    margin: ${({ marginM }) => marginM};
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: ${({ sizeMobileL }) => sizeMobileL};
  }

  @media ${({ theme }) => theme.deviceMin.desktop1890} {
    padding: ${({ paddingFrom1890 }) => paddingFrom1890};
  }
`;

export const FeaturesContainer = styled.div`
  background-image: url(${MapSVG});
  background-repeat: no-repeat;
  background-size: contain;
  padding: ${({ padding }) => padding || '50px 80px'};
  max-width: ${({ maxWidth }) => maxWidth};

  ${({ theme, bgNone }) =>
    bgNone &&
    css`
      background-image: none;
    `}
`;

export const CarouselWrapper = styled.div`
  &&& {
    .slick-slide {
      /* width: 262px !important; */
      /* margin: 0 10px 0 10px !important */
    }

    .slick-track {
      width: 30000px !important;
    }
  }
`;

export const FeatureItem = styled.div`
  width: ${({ width }) => width || '170px'};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  i {
    font-size: 42px;
    color: ${({ theme }) => theme.colors.primary};
  }

  @media ${({ theme }) => theme.device.tablet} {
    width: 133px;
    margin-bottom: 30px;
    flex: 0 0 50%;
    max-width: 216px;
  }
`;

export const FeatureIcon = styled.div`
  width: ${({ width }) => width || '105px'};
  height: ${({ height }) => height || '105px'};
  background: #ffffff;
  box-shadow: 0px 6px 40px rgba(0, 82, 180, 0.16);
  border-radius: 100%;
  display: ${({ display }) => display || 'flex'};
  text-align: ${({ textAlign }) => textAlign};
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.laptop1100} {
    width: 90px;
    height: 90px;
    i {
      font-size: 28px;
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${({ theme }) => theme.device.tablet} {
    width: 77px;
    height: 77px;
    i {
      font-size: 28px;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 4px rgba(206, 206, 206, 0.2),
      0px -1px 16px rgba(0, 0, 0, 0.05), 0px 0px 4px rgba(206, 206, 206, 0.25);
    transform: scale(0.98);
    /* transform: translateY(-0.5rem); */
  }
`;

export const CardPopularWrapper = styled.div`
  padding: 0;

  &&& {
    .slick-slide {
      width: clamp(321px, 42vw, 410px) !important;
      margin: 0 10px 0 10px !important;
    }

    .slick-track {
      width: 300000px !important;
    }
  }
`;

export const CardPopularOverlay = styled.div`
  &::after {
    transition: all ease-in-out 0.3s;
    max-width: 410px;
    content: '';
    background: rgba(7, 7, 7, 0);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* z-index: -1; */
  }
`;

export const CardPopular = styled.div`
  width: clamp(284px, ${({ width }) => width}, 410px);
  height: clamp(230px, ${({ height }) => height}, 380px);
  display: block;
  margin: ${({ margin }) => margin || 'auto'};
  box-shadow: ${({ shadow }) => shadow};
  background-image: url(${({ bgImg }) => bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 25px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  cursor: grab;
  transition: all ease-in-out 0.3s;
  position: relative;
  &:hover ${CardPopularOverlay} {
    &::after {
      transition: all ease-in-out 0.3s;
      background: rgba(7, 7, 7, 0.25);
    }
  }

  .image {
    min-height: 200px;
    max-height: 230px;
    height: 230px;
  }

  @media ${({ theme }) => theme.device.laptop1100} {
    min-width: clamp(321px, ${({ widthLaptop }) => widthLaptop}, 370px);
    border-radius: 25px;
  }

  @media ${({ theme }) => theme.device.tabletSmall} {
    width: clamp(214px, ${({ widthM }) => widthM}, 284px);
    height: clamp(170px, ${({ heightM }) => heightM}, 230px);
    border-radius: 25px;
  }
`;

export const CardPopularDirections = styled.div`
  width: 100%;
  max-width: 410px;
  height: 400px;
  display: block;
  // margin: auto;
  background-image: url(${({ bgImg }) => bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 25px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  cursor: grab;
  transition: all ease-in-out 0.3s;
  position: relative;
  &:hover ${CardPopularOverlay} {
    &::after {
      transition: all ease-in-out 0.3s;
      background: rgba(7, 7, 7, 0.25);
    }
  }
`;

export const CardPopularInfo = styled.div`
  max-width: 410px;
  width: 100%;
  padding: 30px;
  position: relative;
  z-index: 2;
  &::after {
    max-width: 410px;
    content: '';
    background: linear-gradient(
      360deg,
      rgba(7, 7, 7, 0.75) -24.34%,
      rgba(52, 52, 52, 0) 100%
    );
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
`;

export const CardViewedVillas = styled.div`
  /* max-width: 385px; */
  width: 100%;
  padding: 0;
  position: relative;
  z-index: 2;
  /* &::after {
    max-width: 400px;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  } */
`;

export const RegionStyles = styled.div`
  .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    transform: rotate(90deg);
  }

  .ant-collapse-item-active {
    span[role='img'] {
      svg {
        transform: rotate(180deg) !important;
      }
    }
  }
`;

export const MasonryWrapper = styled.div`
  width: 100%;
  height: auto;

  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);

  @media ${({ theme }) => theme.device.laptopL} {
    grid-auto-rows: minmax(65px, auto);
  }

  @media ${({ theme }) => theme.device.laptop} {
    // grid-template-columns: repeat(2, 1fr); временно скрываем
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(50px, auto);
    grid-gap: 19px;
  }

  @media ${({ theme }) => theme.device.tablet} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 11px;
  }

  @media ${({ theme }) => theme.device.tablet550} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 11px;
  }
`;

export const MasonryItemOverlay = styled.div`
  &::after {
    transition: all ease-in-out 0.3s;
    max-width: 100%;
    content: '';
    background: rgba(7, 7, 7, 0);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* z-index: -1; */
  }
`;

export const MasonryItem = styled.div`
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  /* background-attachment: fixed; */
  cursor: pointer;
  transition: all ease-in-out 0.3s;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  position: relative;

  &:hover ${MasonryItemOverlay} {
    &::after {
      transition: all ease-in-out 0.3s;
      background: rgba(7, 7, 7, 0.25);
    }
  }
  /*
}
         &:hover {
           box-shadow: 0px 10px 50px rgba(0, 82, 180, 0.1);
           transform: scale(0.98);
         } */
`;

export const MasonryItemOne = styled(MasonryItem)`
  grid-row: 1 / 5;

  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 1 / 3;
    grid-column: 2 /3;
    height: 52vw;
  }
`;

export const MasonryItemTwo = styled(MasonryItem)`
  grid-row: 1 / 6;
  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 2 / 4;
    grid-columns: 1 / 2;
    height: 59.5vw;
  }
`;

export const MasonryItemThree = styled(MasonryItem)`
  grid-row: 1 / 5;

  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    height: 38.5vw;
  }
`;

export const MasonryItemFour = styled(MasonryItem)`
  grid-row: 5 / 10;

  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 3 / 4;
    margin-top: -52px;
    height: 46vw;
  }
`;

export const MasonryItemFive = styled(MasonryItem)`
  grid-row: 6 / 10;

  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 4 / 6;
    height: 57.57vw;
  }
`;

export const MasonryItemSix = styled(MasonryItem)`
  grid-row: 5 / 10;

  @media ${({ theme }) => theme.device.tablet550} {
    grid-row: 4 / 6;
    height: 57.57vw;
  }
`;

export const MasonryInfo = styled.div`
  width: 100%;
  padding: 30px;
  position: relative;
  z-index: 2;
  &::after {
    width: 100%;
    content: '';
    background: linear-gradient(
      360deg,
      rgba(7, 7, 7, 0.75) -24.34%,
      rgba(52, 52, 52, 0) 100%
    );
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: ${({ paddingM }) => paddingM || '15px'};
  }
`;

export const OtherProduct = styled.div`
  display: flex;
  flex-grow: 1;
  padding: 0 20px;
  border-left: 1px solid ${({ theme }) => theme.colors.borders.main};
`;

export const DotContainer = styled.div`
  i {
    margin-top: 10px;
  }
`;

export const OtherAccomodationCard = styled.div`
  min-height: 200px;
  padding: 15px;
  border-radius: 12px;
  ${({ theme }) => theme.colors.borders.main}
  border-radius: 8px;
  img {
    border-radius: 10px;
    margin: auto;
  }

  transition: all ease-in-out 0.3s;
  &:hover {
    cursor: pointer;
  }
`;

export const BlogCardContainer = styled.div``;

export const BlogCard = styled.div`
  display: block;
  margin: auto;
  width: ${({ width }) => width};
  min-height: 284px;
  border-radius: 12px;
  ${({ theme }) => theme.colors.borders.main}
  background: #ffffff;
  box-shadow: 0px 10px 50px rgba(0, 82, 180, 0.1);
  border-radius: 20px;
  overflow: hidden;
  img {
    border-radius: 10px;
    margin: auto;
  }

  transition: all ease-in-out 0.3s;
  &:hover {
    cursor: pointer;
  }
`;

export const ImgCard = styled.div`
  border-radius: ${({ radius }) => radius || '10px'};
  margin: auto;
  width: ${({ width }) => width || '378px'};
  height: ${({ height }) => height || '221px'};
  background-image: url(${({ img }) => img});
  background-position: center;
  position: relative;
`;

export const BlogInfo = styled.div`
  height: 113px;
  padding: 15px 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    359.72deg,
    rgba(0, 0, 0, 0.5) 10.66%,
    rgba(0, 0, 0, 0) 99.31%
  );
`;

export const VideoContainerPaddingController = styled.div`
  @media (max-width: 1250px) {
    // padding: 0 5%;
  }
  @media (max-width: 450px) {
    padding: 0;
  }
`;

export const VideoContainer = styled.div`
  float: right;
  width: ${({ width }) => width || '519px'};
  min-width: ${({ minWidth }) => minWidth};
  height: 349px;
  position: relative;
  background-image: url(${RectangleSVG});

  ${({ theme, bgNone }) =>
    bgNone &&
    css`
      background-image: none;
    `}

  @media ${({ theme }) => theme.device.tablet} {
    background-image: none;
  }
`;

export const VideoItemTablet = styled.div`
  width: ${({ width }) => width || '519px'};
  height: 349px;
  border-radius: 20px;
  overflow: hidden;
  text-align: ${({ textAlign }) => textAlign};

  @media (max-width: 450px) {
    border-radius: 0;
  }
`;

export const VideoItem = styled.div`
  width: ${({ width }) => width || '519px'};
  height: 349px;
  background-color: rgba(0, 0, 0, 0.5);
  background-image: url(${({ img }) => img});
  border-radius: 20px;
  position: absolute;
  bottom: ${({ bottom }) => bottom || '-33px'};
  left: ${({ left }) => left || '-36px'};
  overflow: hidden;
  @media ${({ theme }) => theme.device.tablet} {
    border-radius: 0;
  }
`;

export const SubscriptionContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  min-height: 210px;
  background: #ffffff;
  padding: 50px 70px;
  box-shadow: 0px 10px 50px rgba(0, 82, 180, 0.1);
  border-radius: 20px;
  display: block;
  margin: 140px auto 90px auto;

  @media ${({ theme }) => theme.device.tablet} {
    margin: 50px auto 90px auto;
    padding: 30px 20px;
  }
`;
